import React from "react";
import MarkdownIt from "markdown-it";
import DOMPurify from "dompurify";
import "./MarkdownDisplay.css";
const md = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true,
});
const isPersianText = (text) => {
  return /[\u0600-\u06FF]/.test(text);
};
export function convertMarkdownToSafeHtml(markdownText) {
  const rawHtml = md.render(markdownText);
  return DOMPurify.sanitize(rawHtml);
}


const MarkdownDisplay = ({ markdownText }) => {
  const safeHtmlContent = convertMarkdownToSafeHtml(markdownText);
  const isRTL = isPersianText(markdownText);
  return (
    <div
    className={`prose max-w-none markdown-content ${
      isRTL ? "rtl" : "ltr"
    }`}
      // className="prose max-w-none markdown-content"
      // className="max-w-none markdown-content"
  //     className="
  //   prose max-w-none 
  //   prose-p:my-1     
  //   prose-ul:my-1    
  //   prose-li:my-0    
  //   prose-h2:my-2    
  //   markdown-content
  // "
      dangerouslySetInnerHTML={{ __html: safeHtmlContent }}
    />
  );
};
export default MarkdownDisplay;